var _Path, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgOnlineBorder = function SvgOnlineBorder(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 112.822 112.708"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "url(#online-border_svg__a)",
    strokeWidth: 1.058,
    d: "M56.411.53c30.863 0 55.882 24.993 55.882 55.823S87.274 112.18 56.411 112.18.53 87.184.53 56.353C.53 25.524 25.548.53 56.411.53Z"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "online-border_svg__a",
    x1: 56.411,
    x2: 56.411,
    y1: 112.708,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFF908"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFFF9E"
  })))));
};
export default SvgOnlineBorder;